/* PDP redesign (2026) - small enhancements. Loaded only when the section
   "PDP redesign marker" block is on the template. Every block is defensive: if the theme
   markup changes, the page still works and the enhancement simply does not run. */
(function () {
  'use strict';
  var marker = document.querySelector('.pdp-marker');
  var root = marker && marker.closest('.ptContainer');
  if (!root) return;
  var mobile = window.matchMedia('(max-width: 767px)');

  /* 1. Keep the sticky buy panel just under the sticky header */
  function setTop() {
    var h = document.getElementById('header');
    var ann = document.getElementById('shopify-section-top-info-panel');
    var top = 0;
    if (ann && getComputedStyle(ann).position === 'sticky') top += ann.offsetHeight;
    if (h) {
      var cs = getComputedStyle(h);
      top += (cs.position === 'fixed' || cs.position === 'sticky') ? h.offsetHeight : 0;
    }
    root.style.setProperty('--pdp-top', (top ? top + 12 : 12) + 'px');
  }
  setTop();
  window.addEventListener('resize', setTop, { passive: true });
  window.addEventListener('scroll', (function () {
    var t; return function () { clearTimeout(t); t = setTimeout(setTop, 120); };
  })(), { passive: true });

  /* 2. Mobile gallery: "2 / 7" counter + segmented progress bar */
  function galleryCounter() {
    var slider = root.querySelector('.primgSlider');
    var wrap = root.querySelector('.pr_lg_img');
    if (!slider || !wrap || wrap.querySelector('.pdp-gcount')) return;
    var cells = slider.querySelectorAll('.pr_photo');
    if (cells.length < 2) return;
    var ct = document.createElement('span'); ct.className = 'pdp-gcount'; ct.setAttribute('aria-hidden', 'true');
    var bar = document.createElement('div'); bar.className = 'pdp-gbar'; bar.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < cells.length; i++) bar.appendChild(document.createElement('i'));
    wrap.style.position = 'relative';
    wrap.appendChild(ct);
    wrap.parentNode.insertBefore(bar, wrap.nextSibling);
    function update(idx) {
      ct.textContent = (idx + 1) + ' / ' + cells.length;
      var s = bar.children; for (var j = 0; j < s.length; j++) s[j].className = j === idx ? 'on' : '';
    }
    update(0);
    var f = (window.Flickity && Flickity.data) ? Flickity.data(slider) : null;
    if (f && f.on) { f.on('select', function () { update(f.selectedIndex); }); }
    else {
      slider.addEventListener('scroll', function () { update(Math.round(slider.scrollLeft / slider.clientWidth)); }, { passive: true });
    }
  }
  if (mobile.matches) { window.addEventListener('load', function () { setTimeout(galleryCounter, 400); }); }

  /* 3. Mobile sticky buy bar: appears once the main Add to bag has scrolled away */
  function stickyBar() {
    var btn = root.querySelector('.product-form__submit');
    if (!btn || document.querySelector('.pdp-mbar')) return;
    var title = (root.querySelector('h1.product-single__title') || {}).textContent || document.title;
    var bar = document.createElement('div');
    bar.className = 'pdp-mbar'; bar.setAttribute('role', 'region'); bar.setAttribute('aria-label', 'Quick add to bag');
    bar.innerHTML = '<div class="mi"><div class="mn"></div><div class="mp"></div></div><button type="button"></button>';
    bar.querySelector('.mn').textContent = title.trim();
    var b = bar.querySelector('button');
    document.body.appendChild(bar);
    function sync() {
      var priceEl = root.querySelector('.psinglePriceWr .psinglePrice.sale, .psinglePriceWr .psinglePrice');
      bar.querySelector('.mp').textContent = priceEl ? priceEl.textContent.replace(/\s+/g, ' ').trim() : '';
      var t = btn.querySelector('.txt');
      b.textContent = (t ? t.textContent : btn.textContent).replace(/\s+/g, ' ').trim();
      b.disabled = btn.disabled;
    }
    sync();
    new MutationObserver(sync).observe(btn, { childList: true, subtree: true, attributes: true });
    var pw = root.querySelector('.psinglePriceWr');
    if (pw) new MutationObserver(sync).observe(pw, { childList: true, subtree: true, characterData: true });
    b.addEventListener('click', function () { btn.click(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var e = es[0];
        var gone = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('show', mobile.matches && gone);
      }, { threshold: 0 }).observe(btn);
    }
  }
  stickyBar();

  /* 4. "Save Rs X . N% off" next to the price when a compare-at (MRP) price exists */
  function priceBadge() {
    var pw = root.querySelector('.psinglePriceWr');
    if (!pw) return;
    var busy = false;
    function num(el) { var m = el && el.textContent.replace(/,/g, '').match(/\d+(?:\.\d+)?/); return m ? parseFloat(m[0]) : NaN; }
    function render() {
      if (busy) return; busy = true;
      var cur = num(pw.querySelector('.psinglePrice.sale span, .psinglePrice.sale, .psinglePrice:not(s) span'));
      var was = num(pw.querySelector('s.psinglePrice'));
      var el = pw.querySelector('.pdp-save');
      if (cur > 0 && was > cur) {
        var diff = was - cur, pct = Math.round(diff * 100 / was);
        var txt = 'Save ₹' + diff.toLocaleString('en-IN') + ' · ' + pct + '% off';
        if (!el) { el = document.createElement('span'); el.className = 'pdp-save'; var s = pw.querySelector('s.psinglePrice'); s.parentNode.insertBefore(el, s.nextSibling); }
        if (el.textContent !== txt) el.textContent = txt;
      } else if (el) { el.remove(); }
      busy = false;
    }
    render();
    new MutationObserver(function () { setTimeout(render, 0); }).observe(pw, { childList: true, subtree: true, characterData: true });
  }
  priceBadge();
})();
